// extracted by mini-css-extract-plugin
module.exports = {"fallback":"hAN4EdAl","flag":"Y_Xd1nrA","rounded":"UZdipBiR","circular":"gAOo_q_L"};